// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";
import { CustomerInformationModel, FormFieldModel } from "@store/Framework/Types/ApiModels";

const crmUrl = "/api/v1/crm/";

export interface SubmitFormParameter {
    formType: "ValveConfigurator" | "PumpConfigurator" | "CycloneConfigurator" | "ServiceRequest" | "WarrantyClaim";
    formFields: FormFieldModel[];
    customerInformation: CustomerInformationModel;
    userId?: string | null;
    shipToCustomerId?: string | null;
}

export function submitCrmForm(parameter: SubmitFormParameter) {
    return post<SubmitFormParameter, void>(crmUrl + "submitform", parameter);
}
